import vanillaTilt from "vanilla-tilt";
import { useEffect } from "react";
import { useNavigate } from "react-router";

const AboutCard = ({ h1, h2, h3, p, p2, points, diploma }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const cards = document.querySelectorAll(".card");

    cards.forEach((card) => {
      vanillaTilt.init(card, {
        max: 25,
        speed: 400,
        glare: true,
        "max-glare": 0.5,
      });
    });
  }, []);

  return (
    <div class="card">
      <h1>{h1}</h1>
      <div class="content">
        <h2>{h2}</h2>
        <h3>{h3}</h3>
        <p>{p}</p>
        {p2 && <p>{p2}</p>}
        {points && (
          <ul>
            {points.map((point) => (
              <li key={point}>{point}</li>
            ))}
          </ul>
        )}
        {diploma && (
          <p
            onClick={() =>
              navigate("/Maia-Kiknavelidze-Certificate-Digital-Institute")
            }
            className="view-certificate"
            style={{
              cursor: "pointer",
              fontSize: "24px",
            }}
          >
            View Certificate
          </p>
        )}
      </div>
    </div>
  );
};

export default AboutCard;
